/**
 * useWorkMasterList Hook
 * Convenience hook that triggers master data loading and returns the cached store state.
 *
 * Usage:
 *   const { workTypes, schemes, financialYears, loading } = useWorkMasterList();
 */

import { useEffect } from 'react';
import { useMasterListStore } from '../store/masterListStore';

export function useWorkMasterList() {
  const store = useMasterListStore();

  useEffect(() => {
    store.loadAll();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return store;
}
